import axios from "axios";
import { toast } from "react-toastify";

const BaseURL = process.env.REACT_APP_API_PATH;

export const loginUser = async (data) => {
  try {
    const res = await axios.post(`${BaseURL}/login`, data);
    if (res?.data?.data?.isAccountVerified) {
      toast.success(`${res?.data?.data?.userType} Logged In`);
    } else {
      toast.success(`Please verify account`);
    }
    return res.data.data;
  } catch (error) {
    toast.error(
      error?.response?.data?.status?.message ?? "Login failed!",
      { toastId: "loginError" } // unique ID for error toast
    );
    throw error;
  }
};

export const verifyCandidateOtp = async (payload) => {
  try {
    const res = await axios.put(`${BaseURL}/ebench/email_verify`, payload);
    return res.data;
  } catch (error) {
    toast.error(error?.response?.data?.status?.message ?? "Verification failed!", { toastId: "otpError" });
    throw error;
  }
};

export const verifyVendorOtp = async (payload) => {
  try {
    const res = await axios.put(`${BaseURL}/ebench/vendor_email_verify`, payload);
    return res.data;
  } catch (error) {
    toast.error(error?.response?.data?.status?.message ?? "Verification failed!", { toastId: "otpError" });
    throw error;
  }
};

export const resendOtp = async (data) => {
  const response = await axios.put(`${BaseURL}/resend-otp`,
    data,
  );
  return response.data;
};

export const logoutUser = async (userId, userType) => {
  try {
    const response = await axios.post(`${BaseURL}/log_out?userId=${userId}&userType=${userType}`);
    return response.data;
  } catch (error) {
    console.error('Logout API error:', error);
    throw error;
  }
};